module.exports = __webpack_public_path__ + "static/media/01-final.516bd133.webp";